import React, { useEffect, useState } from 'react'
import Navbar from './(atom)/Navbar'
import { useLocation, useNavigate } from 'react-router-dom';
import NavbarAdmin from './NavbarAdmin';
import { jwtDecode } from 'jwt-decode';
import { useCookies } from 'react-cookie';
import NavbarCrew from './NavbarCrew';

const NavbarController = () => {

  const pathActive = useLocation()

  
  const [namaGweh, setNamaGweh] = useState(null);
  const [cookies] = useCookies(["token"]);
  const navigate = useNavigate();

  // Menggunakan useEffect untuk navigasi
  useEffect(() => {
    if(
      pathActive.pathname === "/login" ||
        pathActive.pathname === "/register"
    ){
      return
    }else{
      if (!cookies.token) {
        navigate("/login");
      } else {
        try {
          const token = cookies.token;
          if (typeof token === "string" && token) {
            const userName = jwtDecode(token).email;
            setNamaGweh(userName);
          } else {
            navigate("/login");
            throw new Error("Invalid token format");
          }
        } catch (error) {
          navigate("/login");
        }
      }
    }
  }, [cookies.token, navigate]);

  const [isAdmin, setIsAdmin] = useState(false)
  const [isCrew, setIsCrew] = useState(false)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (
      pathActive.pathname === "/login" ||
      pathActive.pathname === "/register"
    ) {return

    }else{
      if (namaGweh) {
        // Fetch data with async/await
        const fetchData = async () => {
          try {
            const response = await fetch(
              `${process.env.REACT_APP_SERVER}/api/user/${namaGweh}`
            );
            if (!response.ok) throw new Error("Network response was not ok");
            const data = await response.json();
            console.log("🚀 ~ fetchData ~ data.payload.datas.posisi:", data.payload.datas.posisi)
            if(data.payload.datas.posisi === "Admin"){
              setIsAdmin(true)
            }
            if(data.payload.datas.posisi === "Karyawan"){
              setIsCrew(true)
            }
  
            setLoading(false)
            return
            
          } catch (error) {
            setError(`An error occurred: ${error.message}`);
          } finally {
            setLoading(false);
          }
        };
  
        fetchData();
      }
    }

  }, [namaGweh]);

  if (
      pathActive.pathname === "/login" ||
      pathActive.pathname === "/register"
    ) return;
  
  if(loading) return <></>
  if(error) return <div>{error}</div>
  
  if(
    (pathActive.pathname === "/admin" || 
    pathActive.pathname === "/admin/data-user" || 
    pathActive.pathname === "/admin/analysis") && isAdmin === false 
  )navigate('/')
    
  if(
      isAdmin === true
    ) return <NavbarAdmin />
      
  if(
      isCrew === true
    ) return <NavbarCrew />
      
  return <Navbar />
}

export default NavbarController